const COMMON_USER = "COMMON_USER";
const CONFIGURATION_USER = "CONFIGURATION_USER";

export { COMMON_USER, CONFIGURATION_USER}